import { runDownloadTask } from '~/utils/runDownloadTask';

export async function runPaginatedDownloadTask<T>(
  currentPage: number,
  task: () => Promise<T>,
): Promise<T> {
  if (currentPage === 1) {
    return runDownloadTask(task);
  }

  return task();
}
